import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { UnBondInstructionHeader, UnBondInstructionDetail, UnBondStockReport } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class UnBondInstructionHeaderService extends TmsWebBaseEditService<
  UnBondInstructionHeader,
  UnBondInstructionHeader
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('UnBondInstructionHeader', $localize`Bonded Stock`);
  }

  getUnBondInstructionDetails(id: string): Observable<UnBondInstructionDetail[]> {
    return this.httpService.get<UnBondInstructionDetail[]>(`${this.apiUrl}/GetUnBondInstructionDetails?id=${id}`);
  }

  getUnBondedDetailsToPrint(id: string): Observable<UnBondStockReport> {
    return this.httpService.get<UnBondStockReport>(`${this.apiUrl}/GetUnBondedDetailsToPrint?id=${id}`);
  }

  releaseBondedStock(batchId: string, locationId: string, entryNo: string, quantity: number): Observable<string> {
    return this.httpService.post<string>(`${this.apiUrl}/ReleaseBondedStock`, {
      batchId,
      locationId,
      entryNo,
      quantity,
    });
  }
}
